//Utilisé pour le moment uniquement dans la page de controle de facturation
export enum EModule {
	sce = "SCE",
	dtp = "DTP",
	dpcv = "DPCV"
}